// src/components/Header.js
import React, { useState } from 'react'; // Importa useState
import { Navbar, Container, Nav, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../styles/custom.css';

const Header = () => {
    // Estados para controlar la visibilidad de cada dropdown al pasar el ratón
    const [showLaboralDropdown, setShowLaboralDropdown] = useState(false);
    const [showWebDropdown, setShowWebDropdown] = useState(false);

    // Handlers para el dropdown "Calculadoras Laborales"
    const handleLaboralHoverOpen = () => setShowLaboralDropdown(true);
    const handleLaboralHoverClose = () => setShowLaboralDropdown(false);

    // Handlers para el dropdown "Herramientas Web"
    const handleWebHoverOpen = () => setShowWebDropdown(true);
    const handleWebHoverClose = () => setShowWebDropdown(false);
    

    return (

        <Navbar expand="lg" className="header-custom" bg="dark" variant="dark" expand="lg" fixed="top">
            <Container>
<div class="col-xl-3 col-lg-3 col-md-6 align-self-center">
				<div class="site-logo">
									  
						<a href="https://hagamoscuentas.sv/" class="navbar-brand"><img src="https://hagamoscuentas.sv/wp-content/uploads/2025/04/logoHC200x55.svg" alt="hagamoscuentas.sv"/></a>
							  
				</div>
											
			</div>                
                {/* <Navbar.Brand as={Link} to="/" className="text-white">Calculadoras Web</Navbar.Brand> */}
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="navigation">
                    <Nav className="me-auto">
                        <Nav.Link href="https://hagamoscuentas.sv/"  className="text-white">Inicio</Nav.Link>
                        <Nav.Link href="https://hagamoscuentas.sv/articulos/"  className="text-white">Artículos</Nav.Link>

                        {/* Sub-menu 1: Calculadoras Laborales navigation basic-navbar-nav */}
                        <NavDropdown
                            title="Secciones"
                            id="nav-dropdown-laboral"
                            className="text-white"
                            show={showLaboralDropdown} // Controla la visibilidad con el estado
                            onMouseEnter={handleLaboralHoverOpen} // Muestra al entrar el ratón
                            onMouseLeave={handleLaboralHoverClose} // Oculta al salir el ratón
                        >
                            {/* <NavDropdown.Item as={Link} to="/indemnizacion">Empleo</NavDropdown.Item>  */}
                            <NavDropdown.Item href="https://hagamoscuentas.sv/category/empleo/" >Empleo</NavDropdown.Item>
                            <NavDropdown.Item href="https://hagamoscuentas.sv/category/ahorro/">Ahorro</NavDropdown.Item>
                            <NavDropdown.Item href="https://hagamoscuentas.sv/category/jubilacion/">Jubilación</NavDropdown.Item>
                            <NavDropdown.Item href="https://hagamoscuentas.sv/category/gastos/">Gastos</NavDropdown.Item>
                            <NavDropdown.Item href="https://hagamoscuentas.sv/category/tecnologia/">Tecnología</NavDropdown.Item>
                        </NavDropdown>

                        {/* Sub-menu 2: Herramientas Web */}
                        <NavDropdown
                            title="Recursos"
                            id="nav-dropdown-web"
                            className="text-white"
                            show={showWebDropdown} // Controla la visibilidad con el estado
                            onMouseEnter={handleWebHoverOpen} // Muestra al entrar el ratón
                            onMouseLeave={handleWebHoverClose} // Oculta al salir el ratón
                        >
                            <NavDropdown.Item href="https://hagamoscuentas.sv/category/consejos/">Consejos</NavDropdown.Item>
                            <NavDropdown.Item href="https://hagamoscuentas.sv/category/tramites/">Trámites</NavDropdown.Item>
                            <NavDropdown.Item href="https://hagamoscuentas.sv/category/utilitarios-explicativos/">Utilitarios/Explicativos</NavDropdown.Item>
{/*                             <NavDropdown.Item href="#action/4.4">Comprobador SEO Básico</NavDropdown.Item>
                            <NavDropdown.Item href="#action/4.5">Validador JSON/XML</NavDropdown.Item> */}
                        </NavDropdown>
                        <Nav.Link as={Link} to="https://boletines.hagamoscuentas.sv/registro" className="text-white">Newsletter</Nav.Link>

                        {/* <Nav.Link as={Link} to="/form2" className="text-white">Contacto</Nav.Link>
                        <Nav.Link href="#link-5" className="text-white">Acerca de</Nav.Link> */}
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Header;